import dynamic from "next/dynamic";
import WhitePaperData from "../../../white-paper-pdfs.json";
import Link from "next/link";
import Image from "next/image";
import { ChevronsDown } from "lucide-react";
import ContactUsHome from "../../../components/homepage/ContactUsHome";

const Footer = dynamic(() => import("../../../components/Footer"), { ssr: false });
const Navbar = dynamic(() => import("../../../components/Navbar"), { ssr: false });

const Whitepaper = () => {
  const whitePaper = WhitePaperData[0];
  const coverSection = whitePaper.sections.find(section => section.section === "cover");

  function createMarkup(content, quotes = []) {
    let modifiedContent = content;

    if (!Array.isArray(quotes)) {
      quotes = [];
    }

    quotes.forEach((quote, index) => {
      const placeholder = `{{quote_${index + 1}}}`;
      modifiedContent = modifiedContent.replaceAll(
        placeholder,
        `<blockquote class="border-l-4 border-[#f1aa4e] pl-4 italic text-gray-500 font-semibold text-2xl py-5">
          ${quote}
        </blockquote>`,
      );
    });

    return { __html: modifiedContent };
  }

  return (
    <div className="text-black relative">
      <Navbar />

      {coverSection && (
        <section
          className="relative min-h-screen flex flex-col justify-center items-center text-white text-center bg-cover bg-center"
          style={{ backgroundImage: `url(${coverSection.meta.bg_img})` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center text-left px-4 sm:px-10 md:px-20">
            <p className="text-white underline text-sm sm:text-base">Whitepaper</p>
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold max-w-5xl">{coverSection.meta.title}</h1>

            <Link href="/">
              <a className="absolute bottom-5 right-5 sm:flex items-center font-bold gap-2 tracking-wide pl-4 text-sm sm:text-base hidden">
                <div className="w-[1.3rem]">
                  <Image src="/logo.png" alt="Itmtb" height="51" width="33" priority={true} />
                </div>
                ideas that make things better
              </a>
            </Link>
          </div>

          {/* Scroll Button */}
          <button
            onClick={() => window.scrollBy({ top: window.innerHeight, behavior: "smooth" })}
            className="absolute bottom-5 left-1/2 transform -translate-x-1/2 flex flex-col items-center text-white transition hover:translate-y-1"
          >
            Scroll Down
            <ChevronsDown className="w-6 h-6 sm:w-8 sm:h-8" />
          </button>
        </section>
      )}

      {/* Content Section */}
      <div id="whitepaper-content" className="bg-white mb-20 mt-6 max-w-4xl mx-auto prose md:prose-xl px-4 sm:px-6">
        {whitePaper.sections.slice(1).map((section, idx) => (
          <section key={idx} className="mb-6">
            <h2 className="text-2xl sm:text-3xl font-semibold mb-2">{section.meta?.title}</h2>

            {section.section === "content" ? (
              section.subsections.map((subsection, subIdx) => (
                <div key={subIdx} className="mb-4">
                  {subsection.meta?.bg_img && (
                    <div className="relative h-[200px] sm:h-[250px] overflow-hidden flex items-center justify-center">
                      <div
                        className="absolute top-0 left-0 w-full h-screen bg-cover bg-center"
                        style={{
                          backgroundImage: `url(${subsection.meta.bg_img})`,
                          backgroundAttachment: "fixed",
                        }}
                      ></div>
                      <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                      <h3 className="relative text-3xl !m-0 sm:text-4xl font-medium z-10 text-white text-center">{subsection.meta.title}</h3>
                    </div>
                  )}
                  {!subsection.meta?.bg_img && <h3 className="text-3xl sm:text-4xl font-medium">{subsection.meta.title}</h3>}
                  <div dangerouslySetInnerHTML={createMarkup(subsection.content, subsection.meta.quotes)} />
                </div>
              ))
            ) : (
              <div dangerouslySetInnerHTML={createMarkup(section.content)} />
            )}
          </section>
        ))}
        <hr />
      </div>
      <ContactUsHome />
      <Footer />
    </div>
  );
};

export default Whitepaper;
